import type { FaireProductEntity } from "../../entity_types/product";

export const p_444jhvjf56: FaireProductEntity = {
  token: "p_444jhvjf56",
  type: "product",
  name: "Island Girl | Car Diffuser",
  brandName: "Sunshine + Saltwater",
  imageUrl:
    "https://cdn.faire.com/fastly/ca7d95be39717024991154c99f7150f15c95b0b32729c12caf98452a95efa2f2.jpeg",
  priceDollars: 8.5,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/64b08d68f2b515da39483e68aa5a1a75546911df3156f1edf6f1d8d7ee72d5e8.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
